import React, { useRef, useState } from "react";

const NewNextOfNext = ({ onSubmit, onCancel }) => {
	// local state
	const data = [
		"Brother",
		"Father",
		"Mother",
		"Sister",
		"Uncle",
		"Other",
		"Relative"
	];
	const [relationship, setRelationship] = useState();
	// ref
	const name = useRef(null);
	const mobileRef = useRef(null);
	const addressRef = useRef(null);

	return (
		<form
			method="POST"
			onSubmit={event => {
				event.preventDefault();
				onSubmit({
					name: name.current.value,
					relationship,
					address: addressRef.current.value,
					mobile: mobileRef.current.value
				});
				name.current.value = "";
				addressRef.current.value = "";
				mobileRef.current.value = "";
				name.current.focus();
			}}
		>
			<div className="form-group">
				<label htmlFor="name-id">Name</label>
				<input
					type="text"
					className="form-control input-height"
					id="name-id"
					required
					ref={name}
					aria-describedby="name-id"
					placeholder="enter name"
				/>
			</div>
			<div className="form-group">
				<label htmlFor="mobile-id">Mobile</label>
				<input
					type="text"
					className="form-control input-height"
					id="mobile-id"
					required
					ref={mobileRef}
					aria-describedby="mobile-id"
					placeholder="enter mobile"
				/>
			</div>
			<div className="form-group">
				<label htmlFor="relation-id">Relationship to Staff</label>
				<select
					onChange={e => {
						setRelationship(e.target.value);
					}}
					className="form-control input-height"
					required
				>
					<option value="">Select...</option>
					{data.map(item => (
						<option key={item} value={item}>
							{item}
						</option>
					))}
				</select>
			</div>
			<div className="form-group">
				<label htmlFor="address-id">Contact Address</label>
				<textarea
					name="address-id"
					id="address-id"
					ref={addressRef}
					className="form-control form-control-textarea"
					required
					rows="4"
					placeholder="enter contact address"
				></textarea>
			</div>

			<div className="text-center">
				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success"
				>
					Submit <i className="material-icons">arrow_right_alt</i>
				</button>
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default"
				>
					<i className="material-icons text-danger">cancel</i> Cancel
				</button>
			</div>
		</form>
	);
};

export default NewNextOfNext;
